import { render, staticRenderFns } from "./CustomerPartnerCreate.vue?vue&type=template&id=d10afcf0"
import script from "./CustomerPartnerCreate.vue?vue&type=script&lang=js"
export * from "./CustomerPartnerCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports